import React, { Component, createContext } from 'react'
import { Prompt } from 'react-router-dom'
import { connect } from 'react-redux'
import get from 'lodash/get'
import pick from 'lodash/pick'
import toPairs from 'lodash/toPairs'
import { StaticLoader } from 'components/misc/Loader'

export const context = createContext()

export { default as Input } from 'components/Form/Input'

const DEFAULT_BASE_ERROR = { base: (
  <span>Something went wrong. Please try again later or contact <a href={process.env.REACT_APP_SUPPORT_URL} rel="noopener noreferrer" target="_blank">Support</a>.</span>
)}

export function baseError(message, field='base') {
  return Promise.reject({ response: { data: { errors: { [field]: message }}}})
}

class MyPrompt extends Component {
  // Fixes this issue: https://github.com/ReactTraining/react-router/issues/5707#issuecomment-401705120
  state = {
    when: false
  }
  componentDidMount() {
    this.setState({ when: true })
  }
  render() {
    return <Prompt when={this.state.when} message={this.props.message} />
  }
}

class Form extends Component {
  state = {
    errors: {},
    loading: false,
    changed: false,
  }

  validations = {}
  fields = {}
  fieldNames = {}

  addValidation =  (id, validation) => {
    this.validations[id] = validation
  }

  removeValidation =  (id) => {
    delete this.validations[id]
  }

  updateError = (id, error) => {
    const { errors } = this.state
    if (error) {
      errors[id] = error
    } else {
      delete errors[id]
    }
    this.setState({ errors })
  }

  setChanged = () => {
    this.setState({ changed: true })
  }

  addField = (id, name, getValue) => {
    this.fields[id] = getValue
    this.fieldNames[name] = id
  }

  removeField = (id, name) => {
    delete this.fields[id]
    delete this.fieldNames[name]
  }

  getData() {
    const ids = Object.keys(this.fields)
    if (ids) {
      return ids.reduce((data, id) => this.fields[id](data), {})
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.dispatch({ type: 'CLEAR_FLASH', id: 'form-flash' })
    const errors = {}
    Object.keys(this.validations).forEach(id => {
      const validation = this.validations[id]
      const error = validation()
      if (error) {
        errors[id] = error
      } else {
        delete errors[id]
      }
    })
    this.setState({ errors })
    if (Object.keys(errors).length) {
      this.props.dispatch({ type: 'SET_FLASH', flash: { id: 'form-flash', message: 'Please fix errors before continuing.', type: 'error' } })
      console.log('There are Errors', errors, this.fieldNames)
    } else {
      console.log('No Errors')
      this.setState({ loading: true })
      if (this.props.onData) {
        const data = this.getData()
        console.log('data', data)
        this.props.onData(data).catch(error => {
          console.log('ERROR', error)
          let errors = get(error, 'response.data.errors') || DEFAULT_BASE_ERROR
          if (errors) {
            if (typeof errors === 'string') {
              errors = { base: errors }
            } else if (Array.isArray(errors)) {
              errors = { base: errors[0] }
            } else if (!Object.keys(errors).length) {
              errors = DEFAULT_BASE_ERROR
            }
            // Only include errors for fields that were submitted.
            const fieldErrors = toPairs(pick(errors, Object.keys(data)))
            const { errors: existingErrors } = this.state
            const newErrors = {
              ...existingErrors,
              ...fieldErrors.reduce((memo, [name, error]) => ({
                ...memo,
                [this.fieldNames[name]]: error,
              }), {})
            }
            this.setState({ errors: newErrors, loading: false })
            if (errors.base) {
              this.props.dispatch({ type: 'SET_FLASH', flash: { id: 'form-flash', message: errors.base, type: 'error' } })
            }
          }
        }).then(() => {
          this.setState({ loading: false })
        })
      }
    }
  }

  provided() {
    return {
      errors: this.state.errors,
      addValidation: this.addValidation,
      removeValidation: this.removeValidation,
      updateError: this.updateError,
      setChanged: this.setChanged,
      addField: this.addField,
      removeField: this.removeField,
      formId: this.props.id,
      loading: this.state.loading,
    }
  }

  render() {
    return (
      <context.Provider value={this.provided()}>
        <form id={this.props.id} className={this.props.className} onSubmit={this.handleSubmit}>
          {this.props.children}
          {this.state.loading && <StaticLoader />}
          {this.props.warn && (
          <MyPrompt
            message={args => {
              if (this.state.loading) {
                return true
              }
              if (this.state.changed) {
                return 'Are you sure you want to leave? Your changes will not be saved.'
              }
              return true
            }}
          />
        )}
        </form>
      </context.Provider>
    )
  }
}

export default connect()(Form)